import {
  Link,
  ShareEmailIcon,
  ShareFacebookIcon,
  ShareTwitterIcon,
} from '@paypalcorp/pp-react';
import React from 'react';
import * as analytics from '../lib/analytics';

export default class extends React.Component {
  handleClick = (event) => {
    event.preventDefault();
  };

  handleFBClick = (socialShareType, url) => {
    let fbShareMsg = this.props.fbDesc;
    let name = this.props.fbTitle;
    let link = url;
    let caption = this.props.i18n('label.fb-caption');
    let picture = `https://${this.props.cdnHost}/webstatic/icon/pp258.png`;
    let constructUrl = `https://www.facebook.com/dialog/feed?app_id=321983581337375&name=${name}&display=popup&caption=${caption}&description=${fbShareMsg}&picture=${picture}&link=${link}`;
    window.open(
      constructUrl,
      'facebook',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );

    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleAnalytics = (socialShareType) => {
    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleKeyPress(e, callback) {
    if (e.key === 'Enter') {
      return callback();
    }
  }

  render() {
    let twitterShareMsg = this.props.i18n('label.twitter-share-msg');
    let mailShareMsg = this.props.i18n('label.mail-share-msg');
    let twitterUrl = encodeURI(
      'https://twitter.com/intent/tweet?text=' + twitterShareMsg
    );
    let mailSubject = this.props.i18n('label.mail-subject');
    let mailUrl = `mailto:?subject=${mailSubject}&body=${mailShareMsg}`;

    return (
      <div className='share-social'>
        <ul
          style={{
            listStyle: 'none',
          }}
        >
          <li
            tabIndex='0'
            role='link'
            onKeyDown={(e) =>
              this.handleKeyPress(
                e,
                this.handleFBClick.bind(this, 'facebookshare', this.props.url)
              )
            }
          >
            <Link
              leftIcon={<ShareFacebookIcon size='xl' />}
              onClick={this.handleFBClick.bind(
                this,
                'facebookshare',
                this.props.url
              )}
            />
          </li>
          <li
            tabIndex='0'
            role='link'
            onKeyDown={(e) =>
              this.handleKeyPress(e, () => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(twitterUrl, '_blank');
              })
            }
          >
            <Link
              leftIcon={<ShareTwitterIcon size='xl' />}
              onClick={() => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(twitterUrl, '_blank');
              }}
            />
          </li>
          <li
            tabIndex='0'
            role='link'
            onKeyDown={(e) =>
              this.handleKeyPress(e, () => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(mailUrl, '_blank');
              })
            }
          >
            <Link
              leftIcon={<ShareEmailIcon size='xl' />}
              onClick={() => {
                this.handleAnalytics.bind(this, 'mailshare');
                window.open(mailUrl, '_blank');
              }}
            />
          </li>
        </ul>
      </div>
    );
  }
}
